module.exports = __webpack_public_path__ + "img/195.e1cf3a89.jpg";